import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

const ItemTypeAnalysis = ({ data }) => {
    if (!data) return null;

    const typeChartData = data.by_item_type ? {
        labels: data.by_item_type.map(t => t.item_type),
        datasets: [{
            data: data.by_item_type.map(t => t.revenue),
            backgroundColor: COLORS.slice(0, data.by_item_type.length),
        }],
    } : null;

    const ladiesData = data.ladies_vs_others ? {
        labels: ['Ladies Items', 'Others'],
        datasets: [{
            data: [data.ladies_vs_others.ladies_revenue, data.ladies_vs_others.others_revenue],
            backgroundColor: ['#EC4899', '#6B7280'],
        }],
    } : null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Item Type & Ladies Items Analysis</h6>
                <div className="row">
                    {data.by_item_type && data.by_item_type.length > 0 && (
                        <div className="col-md-6">
                            <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Revenue by Item Type</h6>
                            <div style={{ maxHeight: 200, maxWidth: 200, margin: '0 auto' }}>
                                <Doughnut data={typeChartData} options={{ plugins: { legend: { position: 'bottom', labels: { font: { size: 10 } } } } }} />
                            </div>
                            <div className="table-responsive mt-2">
                                <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.75rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>Type</th>
                                            <th className="text-end">Revenue</th>
                                            <th className="text-end">%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.by_item_type.map((t, i) => (
                                            <tr key={i}>
                                                <td>{t.item_type}</td>
                                                <td className="text-end">{t.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                                <td className="text-end">{t.percentage}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    {data.ladies_vs_others && (
                        <div className="col-md-6">
                            <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Ladies vs Others</h6>
                            <div style={{ maxHeight: 200, maxWidth: 200, margin: '0 auto' }}>
                                <Doughnut data={ladiesData} options={{ plugins: { legend: { position: 'bottom', labels: { font: { size: 10 } } } } }} />
                            </div>
                            <div className="text-center mt-2" style={{ fontSize: '0.8rem' }}>
                                <span className="text-pink">Ladies: {data.ladies_vs_others.ladies_pct}%</span>
                                <span className="mx-2">|</span>
                                <span>Items: {data.ladies_vs_others.ladies_count}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ItemTypeAnalysis;
